import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, combineReducers } from "redux";
import token from "./reducers/token";
import LogIn from "./screens/LogIn";
import SignUp from "./screens/SignUp";
import Home from "./screens/Home";
import Transactions from "./screens/Transactions";
import Contact from "./screens/Contact";
import Paiement from "./screens/Paiement";
import DailyReport from "./screens/DailyReport";
import Settings from "./screens/Settings";
import Clients from "./screens/Clients";
import Referrals from "./screens/Referrals";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import MonthlyReport from "./screens/MonthlyReport";

const store = createStore(combineReducers({ token }));

const theme = createTheme({
  palette: {
    primary: {
      main: "#006EFF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C1C5D8",
      contrastText: "#fff",
    },
    common: {
      main: "#222629",
      contrastText: "#fff",
    },
  },
  typography: {
    allVariants: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
    },
    button: {
      textTransform: "none",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route path="/" exact component={LogIn} />
            <Route path="/inscription" component={SignUp} />
            <Route path="/home" component={Home} />
            <Route path="/transactions" component={Transactions} />
            <Route path="/contact" component={Contact} />
            <Route path="/paiement" component={Paiement} />
            <Route path="/rapports-journaliers" component={DailyReport} />
            <Route path="/parametres" component={Settings} />
            <Route path="/parrainage" component={Referrals} />
            <Route path="/clients" component={Clients} />
            <Route path="/rapport-mensuel" component={MonthlyReport} />
          </Switch>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
